import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/pages'], resolve)
    },
    {
      path: '/contact',
      component: resolve => require(['@/pages/Contact'], resolve)
    },
    {
      path: '/agreement',
      component: resolve => require(['@/pages/Agreement'], resolve)
    },
    {
      path: '/privacy',
      component: resolve => require(['@/pages/Privacy'], resolve)
    },
    {
      path: '/sample',
      component: resolve => require(['@/pages/Sample'], resolve)
    },
    {
      path: '/docs',
      component: resolve => require(['@/pages/Docs'], resolve),
      children: [
        {
          path: '0',
          component: resolve => require(['@/pages/Docs0'], resolve)
        },
        {
          path: '1',
          component: resolve => require(['@/pages/Docs1'], resolve)
        },
        {
          path: '2',
          component: resolve => require(['@/pages/Docs2'], resolve)
        },
        {
          path: '3',
          component: resolve => require(['@/pages/Docs3'], resolve)
        },
        {
          path: '4',
          component: resolve => require(['@/pages/Docs4'], resolve)
        },
        {
          path: '5',
          component: resolve => require(['@/pages/Docs5'], resolve)
        },
        {
          path: '6',
          component: resolve => require(['@/pages/Docs6'], resolve)
        },
        {
          path: '7',
          component: resolve => require(['@/pages/Docs7'], resolve)
        }
      ]
    },
    {
      path: '/download',
      component: resolve => require(['@/pages/Download'], resolve)
    },
    {
      path: '*', // 此处需特别注意置于最底部
      redirect: '/'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/utils/router.js